import React, { useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import { NO_MATCH_UNPAID_WORKPLACE_PROBLEM_URL } from '../../public/external-links'

export interface IUnpaidWagesNoMatchProps {
  reset: () => void
}

const UnpaidWagesNoMatch = (props: IUnpaidWagesNoMatchProps) => {
  const mountedRef = useRef(false)
  useEffect(() => {
    mountedRef.current = true
    if (mountedRef.current) {
      window.scroll(0, 0)
    }
    return () => {
      mountedRef.current = false
    }
  }, [])

  return (
    <>
      <h1>No match</h1>
      <p>
        We&apos;re not holding any unpaid wages under that name from that
        business.
      </p>
      <p>You can:</p>
      <ul>
        <li>
          <Link to="#" onClick={props.reset}>
            search another name or business
          </Link>
        </li>
        <li>
          check what you should be paid for a current or previous job, using our{' '}
          <a href="https://calculate.fairwork.gov.au/findyouraward">
            Pay Calculator
          </a>
        </li>
        <li>
          get{' '}
          <a href={NO_MATCH_UNPAID_WORKPLACE_PROBLEM_URL}>
            Help resolving workplace issues
          </a>
          .
        </li>
      </ul>
    </>
  )
}

export default UnpaidWagesNoMatch
